define('home/templates/anonNav',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"spacing-top-narrow\">\n<a href=\"/home/explore/\"\nclass=\"button button-explore button-small hidden-md\"\ndata-role=\"icon-links\">\n<span class=\"icon-explore button-explore__icon\"></span>\n"
    + alias2(helpers.gettext.call(alias1,"Explore",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n<a href=\"https://disqus.com/profile/login/\"\nclass=\"button button-outline button-small spacing-right-small\"\ndata-action=\"navigate-return\">\n"
    + alias2(helpers.gettext.call(alias1,"Log In",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n<a href=\"https://disqus.com/profile/signup/\"\nclass=\"button button-fill--brand button-small\"\ndata-action=\"navigate-return\">\n"
    + alias2(helpers.gettext.call(alias1,"Sign Up",{"name":"gettext","hash":{},"data":data}))
    + "\n</a>\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<nav class=\"site-nav section-contained\">\n<div class=\"site-nav__item -logo\">\n"
    + ((stack1 = container.invokePartial(partials.navLogo,depth0,{"name":"navLogo","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n"
    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.sessionIsFetching : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</nav>\n";
},"usePartial":true,"useData":true})

});
